import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function RequireAuth({ children, requireAdmin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        data-testid="auth-check-loading"
        className="min-h-screen flex items-center justify-center"
      >
        <Loader2 className="h-8 w-8 text-brand-blue animate-spin" strokeWidth={2} />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  if (requireAdmin && !user.is_admin) {
    return (
      <div
        data-testid="admin-403"
        className="min-h-screen flex flex-col items-center justify-center text-center p-6"
      >
        <h1 className="font-heading text-2xl font-semibold text-ink-900">
          Admins only
        </h1>
        <p className="mt-2 text-ink-600">
          You don&apos;t have permission to view this page.
        </p>
      </div>
    );
  }

  return children;
}
